<template>
  <div class="container-info">
    <div class="header-shadow"></div>

    <!-- <div class="title" v-if="$mq == 'desktop'"> -->
    <div class="titleClassF">
      <span>
        {{ $t('userAccount.personalInformationTitle') }}
      </span>
    </div>

    <div class="profil-infos">
      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.onlylastname') }}</span>
        </div>

        <vv-form-text-input-profil
          label="lastname"
          id="lastname"
          v-model="lastname"
          :validate="'required'"
          :personalInfo="true"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.onlyfirstname') }}</span>
        </div>
        <vv-form-text-input-profil
          label="firstname"
          id="firstname"
          v-model="firstname"
          :validate="'required'"
          :personalInfo="true"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.email') }}</span>
        </div>
        <vv-form-text-input-profil
          label="email"
          id="email"
          v-model="email"
          type="email"
          :validate="'required'"
          :personalInfo="true"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.birthdate') }}</span>
        </div>
        <vv-form-text-input-profil
          id="birthday"
          label="birthday"
          name="birthday"
          v-model="birthday"
          required
          placeholder="JJ/MM/AAAA"
          :cleave="{ date: true, datePattern: ['d', 'm', 'Y'] }"
          :validate="'legalAge|date_format:dd/MM/yyyy'"
          :value="birthdate"
          :personalInfo="true"
        />
      </div>
      <!-- ERROR syntaxe: inside the form for the birthdate (formsJJ/MM/AAAA)-->

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.phone') }}</span>
        </div>
        <vv-form-text-input-profil
          label="phone"
          id="phone"
          v-model="phone"
          :validate="'numeric'"
          :personalInfo="true"
        />
      </div>

      <!-- <div class="content" :class="{ 'content-profil': profil }"> -->
      <div class="content">
        <div class="text-element">
          <span class="gender-label">{{ $t('forms.gender.label') }}</span>
        </div>
        <vv-radio-bubble
          v-for="genderItem in genderList"
          name="genderRadioBubbles"
          :key="genderItem.value"
          :value="genderItem.value"
          :label="genderItem.label"
          v-model="gender"
        />
      </div>
    </div>

    <div class="endBox">
      <vv-form-checkbox-input label="newsletter" id="newsletter" v-model="newsletter" />
    </div>

    <div class="endPage">
      <div class="password-button">
        <span @click.prevent="showPassword = !showPassword" class="change-password-cta">{{
          $t('userAccount.changePassword')
        }}</span>
      </div>
      <div v-if="!showPassword" class="password-button">
        <span class="change-password-cta" @click="goAdressesPage">
          {{ $t('auth.register.updateAdresses') }}
        </span>
      </div>
    </div>

    <div v-if="showPassword" class="old-password-fields">
      <vv-form-text-input-profil
        label="oldPassword"
        id="oldPassword"
        v-model="oldPassword"
        type="password"
        :validate="'required'"
      />
      <vv-form-text-input-profil
        label="newPassword"
        id="newPassword"
        v-model="newPassword"
        type="password"
        :validate="'required'"
      />
      <vv-form-text-input-profil
        label="confirmNewPassword"
        id="confirmNewPassword"
        v-model="confirmNewPassword"
        type="password"
        :validate="'required'"
      />
      <span class="message" v-if="errorPassword">{{ $t(errorPasswordMessage) }}</span>
      <span class="message" v-if="successPassword">{{ $t('forms.updatedWithSuccess') }}</span>
      <div class="boxUpdateBtn">
        <vv-button class="user-form-margin" @click="onPasswordChange">
          {{ $t('forms.updatePassword') }}
        </vv-button>
      </div>
    </div>

    <div v-if="!showPassword" class="boxValidateBtn">
      <vv-button class="validate-button" @click="onUpdate">
        {{ $t('forms.validate') }}
      </vv-button>
    </div>
    <p class="message" v-if="error">{{ $t(errorMessage) }}</p>
    <p class="message" v-if="success">{{ $t('forms.updatedWithSuccess') }}</p>
  </div>
</template>

<script>
import VvFormCheckboxInput from '@/components/common/forms/VvFormCheckboxInput'
import VvRadioBubble from '@/components/common/VvRadioBubble'
import VvButton from '@/components/common/VvButton'
import userMixin from '@/mixins/user'
import VvFormTextInputProfil from './VvFormTextInputProfil.vue'

export default {
  name: 'UserAccountGeneralInformations',
  mixins: [userMixin],
  components: {
    VvFormCheckboxInput,
    VvRadioBubble,
    VvButton,
    VvFormTextInputProfil
  },
  data: () => ({
    firstname: '',
    lastname: '',
    gender: '',
    email: '',
    birthday: '',
    phone: '',
    newsletter: '',
    isLoading: false,
    showPassword: false,
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    error: false,
    errorPassword: false,
    errorMessage: '',
    errorPasswordMessage: '',
    success: false,
    successPassword: false,
    label: ''
  }),
  computed: {
    genderList() {
      return [
        { label: this.$t('forms.gender.male'), value: 'male' },
        { label: this.$t('forms.gender.female'), value: 'female' },
        { label: this.$t('forms.gender.unknow'), value: 'unknow' }
      ]
    },
    birthdate() {
      return this.birthday
    }
  },
  methods: {
    // saveAndGoHome() {
    //   this.$router.push({ name: 'home' })
    // },
    async onPasswordChange() {
      this.errorPassword = false
      this.successPassword = false
      // this.errorPasswordMessage = this.$t('forms.updatedWithError')

      if (this.newPassword && this.confirmNewPassword !== this.newPassword) {
        this.errorPassword = true
        setTimeout(() => (this.errorPassword = false), 2000)
        this.errorPasswordMessage = this.$t('errors.custom/password-mismatch')
        return
      }

      try {
        await this.updateUserPassword(this.oldPassword, this.newPassword)

        this.successPassword = true
        setTimeout(() => (this.successPassword = false), 2000)
      } catch (error) {
        this.errorPassword = true
        if (error.code) {
          // console.log('log', error.code)
          // console.log('log', error.message)
          if (error.code.includes('wrong')) {
            this.errorPasswordMessage = this.$t('errors.wrongPassword')
          } else if (error.code.includes('weak')) {
            this.errorPasswordMessage = this.$t('errors.weakPassword')
          } else {
            this.errorPasswordMessage = this.$t('errors.errorPassword')
          }
        }

        setTimeout(() => (this.errorPassword = false), 2000)
      }
    },
    async onUpdate() {
      let errorValidation = false
      this.error = false
      this.errorMessage = 'forms.updatedWithError'
      this.success = false

      const validFields = await Promise.all(
        this.$children.map(async child => {
          errorValidation = !(await child.$validator.validateAll())
        })
      )

      // validate birthday
      if (validFields.some(verification => verification === false)) {
        return
      }

      if (!errorValidation) {
        const updatePayload = {
          firstname: this.firstname,
          lastname: this.lastname,
          sex: this.gender,
          phone: this.phone,
          birthday: this.birthday,
          newsletter: this.newsletter
        }

        try {
          await this.updateUserInformations(updatePayload)

          this.success = true
          setTimeout(() => (this.success = false), 2000)
        } catch (error) {
          this.error = true
          if (error.code) {
            this.errorMessage = error.code
          }

          setTimeout(() => (this.error = false), 2000)
        }
      }
    },

    goAdressesPage: async function() {
      this.onUpdate()
      this.$router.push({
        name: 'addresses'
      })
    }
  },
  provide() {
    return { $validator: this.$validator }
  },
  created() {
    // console.log(this.user)
    if (this.user) {
      this.firstname = this.user.firstname || ''
      this.lastname = this.user.lastname || ''
      this.gender = this.user.sex || 'unknow'
      this.email = this.user.email
      this.phone = this.user.phone || ''
      this.birthday = this.user.birthday || ''
      this.newsletter = this.user.newsletter || false
    }
  }
}
</script>

<style scoped lang="scss">
.header-shadow {
  display: flex;
  background-image: url('../../../../src/assets/account-background.jpg');
  width: 100%;
  height: 325px;
}

.container-info {
  padding-bottom: 50px;
}
.titleClassF {
  display: flex;
  justify-content: flex-end;
  text-transform: uppercase;
  font: normal normal bold 25px Helvetica;
  color: #404040;
  letter-spacing: 0px;
  color: #404040;
  border: #404040 solid 2px;
  margin-left: -120px;
  width: 60%;
  padding: 10px;
  align-items: center;
  margin-bottom: 50px;
  margin-top: 30px;
}

.title {
  padding-top: 40px;
  padding-bottom: 40px;
}
.old-password-fields {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 20px;
  padding: 10px;
  justify-content: center;
  width: 81%;
  margin: auto;
  margin-top: 0px;
  padding-top: 0px;
}

.boxUpdateBtn {
  width: 100%;
  text-align: left;
}

.user-form-margin {
  // display: flex;
  margin-top: 10px;
  // width : 40%;
  margin-left: 7px;
}
.endPage {
  display: flex;
  align-items: center;
  width: 550px;
  margin: auto;
  margin-top: 20px;
  font-family: normal normal normal 38px/53px DM Sans;
}
.password-button {
  width: 500px;
  margin: 10px;
  margin-left: 30px;
}
.change-password-cta {
  float: left;
  border-radius: 25px;
  background: #404040;
  margin-top: -30px;
  cursor: pointer;
  color: white;
  padding: 10px 15px;
}

.boxValidateBtn {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.validate-button {
  margin-top: 50px;
  margin-bottom: 75px;
  margin: 0px auto;
}
.text-newsletter {
  font-size: 14px;
  font-weight: bold;
  padding: 14px;
}
.text-element {
  font-size: 25px;
  font-weight: bold;
  padding: 10px;

  font-family: 'DM Sans', sans-serif;
  font-style: italic;
  letter-spacing: 0px;
  color: #404040;
  opacity: 1;

  & span {
    font-size: 30px;
  }
}

.content {
  width: 40%;
  min-width: 300px;
}

.profil-infos {
  display: flex;
  gap: 10px;
  gap: 10px 20px;
  row-gap: 10px;
  column-gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.endBox {
  height: 50px;
  width: 300px;
  margin-left: 10%;
  margin-top: 10px;
}

.content-profil {
  width: 120px;
}

.message {
  background-color: #404040;
  color: #ffffff;
  width: 30%;
  height: 1.3rem;
  margin: auto;
  text-align: center;
  border-radius: 10px;
  padding-top: 3px;
}

@media (max-width: 1024px) {
  .header-shadow {
    display: none;
  }
}
@media (max-width: 620px) {
  .container-info {
    padding-bottom: 100px;
  }
  .titleClassF {
    margin-top: 100px;
    margin-left: -70px;
  }

  .endBox {
    height: 50px;
    margin-left: 25%;
    margin-top: 15px;
    width: 250px;
  }
  .endPage {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 100px;
    margin: auto;
    margin-top: 0px;
    font-family: normal normal normal 38px/53px DM Sans;
  }
  .password-button {
    margin: auto;
    width: 230px;
  }

  .boxValidateBtn {
    margin-top: 0px;
    margin-bottom: 75px;
    margin: 0px auto;
  }
  .message {
    margin-top: 20px;
    width: 90%;
  }
}
</style>
